import script from "./myHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./myHeader.vue?vue&type=script&setup=true&lang=js"

import "./myHeader.vue?vue&type=style&index=0&id=4ad59ec8&lang=scss"

const __exports__ = script;

export default __exports__